// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1q-kP","field":"styles_field__2uK3E","fieldCol":"styles_fieldCol__3cwd1","diffCol":"styles_diffCol__1cJYa","diff":"styles_diff__ykcUr"};